import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { FHTMessageType } from "../MessageTypes";
import ChatMessageDto from "../ChatMessageDto";

var RecalledChatMessageDto =
/** @class */
function (_super) {
  __extends(RecalledChatMessageDto, _super);

  function RecalledChatMessageDto(messageId, ioType, deviceType, timestamp) {
    return _super.call(this, messageId, ioType, deviceType, FHTMessageType.Recalled, timestamp) || this;
  }

  RecalledChatMessageDto.prototype.getExcerptText = function () {
    return "该消息已被撤回";
  };

  return RecalledChatMessageDto;
}(ChatMessageDto);

export default RecalledChatMessageDto;